export default __webpack_public_path__ + "static/media/houndci.03fadedd.svg";